import {MatSnackBar, MatProgressBarModule} from '@angular/material';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilsService } from '../shared/utils-service';
 
//import { AlertService, AuthenticationService } from '../_services/index';
 
@Component({
	moduleId: module.id,
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css']
})
 
export class LoginComponent implements OnInit {
	model: any = {};
	private user: any = [];
	private progressBar = false;
	loading = false;
	returnUrl: string;
	private loginurl: string = this.utils.url+"/ddmfLogin/loginValidation";
 
	constructor(
		private route: ActivatedRoute,
		private http: Http,
		private matSnackBar: MatSnackBar,
		private router: Router, 
		private utils: UtilsService
		) {
	 		this.utils._checkSession({'page': 'login'});
	 	}
		//private authenticationService: AuthenticationService,
		//private alertService: AlertService
		
	ngOnInit() {
		// reset login status
		//this.authenticationService.logout();
 
		// get return url from route parameters or default to '/'
		this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
	}
 
	login() {
		this.progressBar = true;
		this.loading = true;
		var headers = new Headers();
		headers.append('Content-Type', 'application/json');
		this.http.post(this.loginurl,JSON.stringify({
			"userId":this.model.username,
			"password":this.model.password
		}), { headers: headers }).subscribe(res => {
		this.progressBar = false;
			this.user = res['_body'];
			this.user = JSON.parse(this.user);
			//console.log(this.user);
			if(this.user.ddmfResponseStatus.responseStatusFlag==true) {
				this.user.timeStamp = new Date().getTime();
				
				
					let home={"router":"home", "menuName":"Home", "menuOrder":"0"};
					var redirect=this.user.listGroupMenus;
						if(this.user.listGroupMenus.length==5){
							redirect.unshift(home);
							}
					
				//DDMF-101 : Start
				//Enforce the first-time login user to change their password
				if(this.user.firstTimeLoginInd=='Y'){
					this.router.navigateByUrl('/change-password');
					sessionStorage.setItem('logged_in_user', JSON.stringify(this.user));
				}//DDMF-101 : End
				else{
					sessionStorage.setItem('logged_in_user', JSON.stringify(this.user));
					var page= "/"+redirect[0].router;
					  this.router.navigateByUrl(page);
				}     
			}
			else{
			}
			var message=this.user.ddmfResponseStatus.responseStatusMessage;
			// this.matSnackBar.open(message, 'Close', {
			//   duration: 1000,
			// });
			this.utils.notify(message);
		},
		error => {
			this.progressBar = false;
			//console.log(error);
			this.utils.notify('Something went wrong!! Please try again later.');
		}); 
	   
	}

}


// WEBPACK FOOTER //
// ./src/app/login/login.component.ts